import { DeviceTypeWithAndroidIOS } from '@/types/configs'
import IconDesktop from '@/components/assets/icon_desktop.svg'
import IconPhone from '@/components/assets/icon_phone.svg'
import IconHeadset from '@/components/assets/icon_headset.svg'

type DeviceIconsProps = {
  deviceType: DeviceTypeWithAndroidIOS[]
}

export default function DeviceIcons({ deviceType }: DeviceIconsProps) {
  const isDesktop = deviceType.includes('desktop')
  const isPhone = deviceType.includes('android') || deviceType.includes('ios')
  const isHeadset = deviceType.includes('hmd')
  return (
    <div className="flex items-center justify-between gap-1">
      {isDesktop && (
        <div className="h-[16px] w-[16px]">
          <IconDesktop />
        </div>
      )}
      {isPhone && (
        <div className="h-[16px] w-[16px]">
          <IconPhone className="h-[16px] w-[16px] [&>path]:fill-[#D5E2F2]" />
        </div>
      )}
      {isHeadset && (
        <div className="h-[16px] w-[16px]">
          <IconHeadset />
        </div>
      )}
    </div>
  )
}
